import React, { useState, useEffect } from 'react';
import '../styles/ArtsAndCraft.css';
import pic1 from "../sciencelabs/artandcraft (1).png";
import pic2 from "../sciencelabs/artandcraft (2).png";
import pic3 from "../sciencelabs/artandcraft (3).png";

const ArtsAndCraft = () => {
  const [currentImageSlide, setCurrentImageSlide] = useState(0);
  const [autoPlay, setAutoPlay] = useState(true);

  // Slider Images Only
  const sliderImages = [
   pic1,
   pic2,
   pic3,
  ];

  // All Activities - Only 3 Available
  const activities = [
    {
      id: 1,
      name: 'Painting',
      description: 'Express creativity through colors and brushstrokes. Learn various painting techniques including watercolor, acrylic, and oil painting to create beautiful artworks.',
      icon: pic1,
    },
    {
      id: 2,
      name: 'Sketching & Drawing',
      description: 'Master the fundamentals of drawing and sketching. Develop observation skills and hand-eye coordination through pencil, charcoal, and ink drawings.',
      icon: pic2,
    },
    {
      id: 3,
      name: 'Paper Art',
      description: 'Transform simple paper into intricate designs. Practice the ancient art of paper folding, cutting, and crafting to create beautiful geometric and organic shapes.',
      icon: pic3,
    }
  ];

  // Auto-play slider
  useEffect(() => {
    if (!autoPlay) return;
    
    const interval = setInterval(() => {
      setCurrentImageSlide((prev) => (prev + 1) % sliderImages.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [autoPlay, sliderImages.length]);

  const nextSlide = () => {
    setAutoPlay(false);
    setCurrentImageSlide((prev) => (prev + 1) % sliderImages.length);
    setTimeout(() => setAutoPlay(true), 5000);
  };

  const prevSlide = () => {
    setAutoPlay(false);
    setCurrentImageSlide((prev) => (prev - 1 + sliderImages.length) % sliderImages.length);
    setTimeout(() => setAutoPlay(true), 5000);
  };

  const goToImageSlide = (index) => {
    setAutoPlay(false);
    setCurrentImageSlide(index);
    setTimeout(() => setAutoPlay(true), 5000);
  };

  return (
    <>
      {/* Arts and Craft Banner */}
      <div className="anc-banner-section">
        <div className="anc-banner-overlay"></div>
        <div className="anc-banner-content">
          <h1 className="anc-banner-title">ARTS AND CRAFT</h1>
        </div>
      </div>

      {/* Main Arts and Craft Section */}
      <section className="anc-main-section" id="anc-artscraft-main">
        {/* About & Slider Container - Side by Side */}
        <div className="anc-about-slider-container">
          {/* Left - About Section */}
          <div className="anc-about-wrapper">
            <div className="anc-description-block">
              <h2 className="anc-section-title">About <span className="anc-title-highlight">Arts and Craft</span></h2>
              <p className="anc-description-text">
                Our Arts and Craft program nurtures creativity, imagination, and artistic expression in students. 
                Through hands-on activities and guided instruction, students explore various art forms and craft techniques. 
                We believe in developing fine motor skills, aesthetic sensibility, and the confidence to express oneself 
                creatively. Our well-equipped art room provides a inspiring space for students to discover their artistic potential.
              </p>
            </div>
          </div>

          {/* Right - Image Slider */}
          <div className="anc-slider-wrapper">
            <div className="anc-image-carousel">
              {/* Image Display */}
              <div className="anc-image-display">
                {sliderImages.map((image, index) => (
                  <div 
                    key={index}
                    className={`anc-image-item ${index === currentImageSlide ? 'anc-image-active' : ''}`}
                  >
                    <img src={image} alt={`Arts and Craft ${index + 1}`} />
                  </div>
                ))}
              </div>

              {/* Navigation Arrows */}
              <button 
                className="anc-image-nav-btn anc-image-nav-prev"
                onClick={prevSlide}
                aria-label="Previous image"
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
              </button>

              <button 
                className="anc-image-nav-btn anc-image-nav-next"
                onClick={nextSlide}
                aria-label="Next image"
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              </button>
            </div>
          </div>
        </div>

        {/* Arts and Craft Activities Section */}
        <div className="anc-content-section">
          <div className="anc-activities-container">
            <h3 className="anc-activities-heading">Our <span className="anc-heading-accent">Activities</span></h3>
            
            <div className="anc-activities-grid">
              {activities.map((activity) => (
                <div 
                  key={activity.id} 
                  className="anc-activity-card"
                >
                  <div className="anc-card-icon">
                    <img src={activity.icon} alt={activity.name} className="anc-item-icon"/>
                  </div>
                  <h4 className="anc-card-title">{activity.name}</h4>
                  <p className="anc-card-desc">{activity.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ArtsAndCraft;